import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output
} from '@angular/core';
import Order from 'src/app/models/Order';
import {OrderPool} from 'src/app/models/OrderPool';
import {STATUS_CHANGE} from 'src/app/services/order.service';
import {PrinterService} from '../../../services/printer.service';
import {Venue} from '../../../models/Venue';
import {checkIfOrder, checkIfOrderPool} from 'src/app/utils/utils';

@Component({
	selector: 'app-manager-order-item-draw',
	templateUrl: './manager-order-item-draw.component.html',
	styleUrls: ['./manager-order-item-draw.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManagerOrderItemDrawComponent implements OnInit {
	orderValue: Order | OrderPool;
	@Input() set order(value: Order | OrderPool) {
		this.orderValue = value;
	}
	@Input() selectedRed: {warning: string; error: string; id: string} | null;
	@Input() venue: Venue | null;
	@Output() sendOrderStatusChange = new EventEmitter<{
		order: Order;
		status: STATUS_CHANGE;
	}>();
	@Input() loadingOrders: string[];
	@Output() sendToPosOrder = new EventEmitter<Order>();
	printerConnected = this.printerService.isConnectedObservable;
	checkIfOrder = checkIfOrder;
	checkIfOrderPool = checkIfOrderPool;

	constructor(
		private printerService: PrinterService,
		private el: ElementRef
	) {
		console.log(this.printerService);
	}
	@Output() sendOrderPoolStatusChange = new EventEmitter<{
		orderPool: OrderPool;
		status: STATUS_CHANGE;
	}>();
	@Input() updateStatusLoading: boolean | null;
	public selectedOrderId: string = '';

	ngOnInit() {}
	updateStatus(data: {order: Order; status: STATUS_CHANGE}) {
		this.sendOrderStatusChange.emit(data);
	}

	printOrder(order: Order, venue: Venue) {
		this.printerService
			.print(order, venue)
			.then(result => {
				console.log('Printing successfully', result);
			})
			.catch(error => {
				console.error(error);
			});
	}
	sendStatusOrderPoolFunc(data: {orderPool: OrderPool; status: STATUS_CHANGE}) {
		console.log('DATA', data);
		this.sendOrderPoolStatusChange.emit(data);
	}

	emitSelectOrderToShow(event: {orderId: string}) {
		console.log(event.orderId);
		this.selectedOrderId = event.orderId;
		this.scrollToOrder(event.orderId);
	}
	scrollToOrder(orderId: string) {
		const element = this.el.nativeElement.querySelector(`#order-${orderId}`);
		if (element) {
			element.scrollIntoView({behavior: 'smooth', block: 'start'});
		}
	}
	sendToPos(order: Order) {
		this.sendToPosOrder.emit(order);
	}
}
